export const maxPerPage = 28;
export const maxInCart = 50;
